function ajusteImageWithLink(){
    console.log("ajusteImageWithLink");
    var images = document.querySelectorAll('.wrapper-image-with-link img');
    console.log('images = '+images);
    for(var i=0; i<=images.length-1; i++){
        var img = images[i];
        var desktop_url = img.getAttribute('data-desktop-url');
        var mobile_url = img.getAttribute('data-mobile-url');
        console.log("desktop_url "+desktop_url)
        var w = window.innerWidth;
        if(w < 768){
            img.src = mobile_url;
        } else {
            img.src = desktop_url;
        }
    }
}
ajusteImageWithLink()
window.addEventListener("resize", ajusteImageWithLink);